import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

export const Api = {
  getActualUrlFromShortenedId: (shortenedId: string) =>
    axios.get(BASE_URL + "/shortened-urls/" + shortenedId),
};
